const Maximize2 = ({setIsMaximizeChatSize}) => {
  return (
    <button
      id="curatu-maximize-chat-window"
      title="Maximize Chat Window"
      className="hover:curai-ring-1 curai-hidden xs:curai-block max-h-400:curai-hidden hover:curai-ring-white focus:curai-box-border curai-border-none curai-text-white curai-bg-transparent curai-p-0"
      onClick={() => setIsMaximizeChatSize(false)}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-maximize-2"
      >
        <polyline points="15 3 21 3 21 9" />
        <polyline points="9 21 3 21 3 15" />
        <line x1="21" x2="14" y1="3" y2="10" />
        <line x1="3" x2="10" y1="21" y2="14" />
      </svg>
    </button>

  );
};

export default Maximize2;
